import { Box, Flex, Grid } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useBlockchainProvider } from 'src/providers/Blockchain/blockchainProvider';
import { ChainIcon } from 'src/utils/icons/chainIcon';
import { PolygonLogo } from 'src/utils/icons/polygonLogo';

const Networks : any = {
	0: "Unknown",
	80001 : 'Mumbai',
	137: 'Polygon'
}

export const NetworkSelector = () => {
	const { isChainValid, chainId } = useBlockchainProvider();
	const { t } = useTranslation();

	return (
		<Grid
			templateAreas="'a b' 'c d'"
			columnGap="7px"
		>
			<Box
				gridArea="b"
				color="#7E7E7E"
				fontSize="12px"
				alignSelf="flex-end"
				textTransform="capitalize"
			>
				{t('network.title')}
			</Box>
			<Flex
				align="flex-start"
				gridArea="c"
			>
				<Flex
					boxSize="14px"
					bg={isChainValid ? '#8247e5' : '#FF3F3F'}
					borderRadius="50%"
					alignItems="center"
					justifyContent="center"
				>
					{isChainValid ? <PolygonLogo></PolygonLogo> : <ChainIcon></ChainIcon>}
				</Flex>
			</Flex>

			<Flex
				align="flex-start"
				gridArea="d"
				fontSize="14px"
				fontWeight="500"
				lineHeight="14px"
				color={isChainValid ? 'white' : '#FF3F3F'}
			>
				{isChainValid ? Networks[chainId] : t('network.error')}
			</Flex>
		</Grid>
	);
};
